<template>
	<v-touch @swipeleft="swiperleft" @swiperight="swiperight" class="frame">
		<div class="container-box">
			<!-- 顶部 -->
			<div class="header">
				<div class="headerFrame">
					<tabBar></tabBar>
				</div>
			</div>
			<!-- 内容 -->
			<div class="content">
				<div class="headerChild">
					<swiper :slideArray="banners"></swiper>
				</div>
				<div class="tabBarFontFrame">
					<div class="tabBarFont">
						<span>{{ tabBarTitle }}</span>
					</div>
					<div class="tabBarFont1">
						<span>{{ tabBarTitle1 }}</span>
					</div>
				</div>
				<!-- 山哩商城 -->
				<div class="shoppingMall">
					<div class="dt mg" v-for="(title,index) in article" :key="index" style="position: relative;">
						<div class="black-div" @click="shadeClick($event)">
							<div class="shade">
								<div class="shade-title">
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{title.titleContent}}</div>
								<div class="shade-line"></div>
								<div class="container" v-if="title.titleUrl != null && title.titleUrl != ''">
									<div class="circle-div" @click="arrowClick(title.titleUrl)">
										<img src="../../assets/YJT.png" alt="arrow" class="arrow-img">
									</div>
								</div>
							</div>
						</div>
						<div class="shoppingMallBg" @click="blackDivClick($event)">
							<img :src="title.fileList[0].filePath" class="imgStyle" />
						</div>
						<div class="serverFrame">
							<div class="serverFrameFont" style="display: inline-block;">
								<div class="serverFrameTitle">
									<span>{{title.titleName}}</span>

								</div>
								<div class="serverFrameContent">
								</div>
							</div>
							<!-- <div style="height: 30px;width: 30px;"><img src="../../assets/bsyjt.png"
									style="height: 100%;width: 100%;" /></div> -->
						</div>
					</div>
				</div>
			</div>
			<fixedBottomRight></fixedBottomRight>
		</div>
	</v-touch>
</template>

<script>
	import tabBar from "@/assembly/tabBarNew.vue";
	import swiper from "@/assembly/mobileSwiper.vue";
	import fixedBottomRight from '@/assembly/fixedBottomRight.vue';
	import {
		getHome
	} from "../../api/home.js";
	export default {
		name: "index",
		data() {
			return {
				tabBarTitle: "新消费智慧供应链生态运营平台",
				tabBarTitle1: "专业化 精细化 特色化 新颖化",
				premiumService: "线上App平台为依托, 探索集成式便民新零售发展路线,",
				premiumService1: "在全国范围布局山哩优品生活服务店",
				farmFrameChildFont: "投资零售和消费品家庭农场作坊, 助力农村经济发展,解决农民就业;同时打造自有品牌、完善自身供应链体系.",
				businessFooterFontContent: "通过商学院联盟, 实现",
				businessFooterFontContent1: "'共创、共享、共生，让事业无边界'",
				show1: false, // 定义第一个div的数据
				show2: false, // 定义第二个div的数据
				show3: false, // 定义第三个div的数据
				article: [],
				banners: []
			};
		},
		created() {
			var modelId = 6;
			var banners = [];
			var article = [];
			var that = this;
			getHome({
				modelId
			}).then((res) => {
				if (res.code == 200 && res.data.length > 0) {

					res.data.forEach((item) => {
						if (item.titleType == 0) { //文章
							var bn = {};
							bn.url = item.fileList[0].filePath;
							banners.push(bn)
						}
						if (item.titleType == 1) { //轮播图
							article.push(item)
						}
					})
					console.log(article)
					that.article = article;
					that.banners = banners;
					this.$nextTick(function() {
						this.handleScroll(); // 在DOM渲染完成后执行myMethod方法
					});
				}
			})
		},
		mounted() {
			window.addEventListener("scroll", this.handleScroll); // 在挂载后监听滚动事件
			this.divs = [ // 定义一个数组，存储每个div的引用和对应的数据
				{
					ref: this.$refs.text1,
					show: "show1",
					threshold: 0
				}
			]

		},
		beforeDestroy() {
			window.removeEventListener("scroll", this.handleScroll); // 在销毁前移除滚动事件
		},
		components: {
			tabBar,
			swiper,
			fixedBottomRight
		},
		methods: {
			swiperleft() {},
			swiperight() {},
			clickbj1() {
				window.location.href = "https://www.yindeng.com.cn/Home/fggf/cn/qgx/20211101/1242473.shtml"
			},
			handleScroll() { // 定义一个方法，用于判断元素是否进入可视区域

				let scrollTop = window.pageYOffset || document.documentElement.scrollTop; // 获取滚动距离
				let elements = document.querySelectorAll('.dt');
				elements.forEach(div => { // 遍历数组中的每个对象
					let offsetTop = div.offsetTop; // 获取元素距离顶部的位置
					let threshold = 0; // 获取元素对应的阈值
					if (scrollTop + window.innerHeight > offsetTop + threshold) { // 判断元素是否进入可视区域
						if (div.classList.contains('animation') == false) { //不存在动画类，则添加
							div.classList.add('animation')
						}
					}
				})
			},
			blackDivClick(e) {
				let btn2 = e.currentTarget.previousElementSibling;
				btn2.classList.add("active"); // 给按钮元素添加一个active类名
			},
			shadeClick(e) {
				let btn = e.currentTarget;
				btn.classList.remove("active"); // 给按钮元素添加一个active类名
			},
			arrowClick(url) {
				this.$router.push({
					name: url
				})
			}
		}
	};
</script>

<style lang="scss" scoped>
	@keyframes moveUp {
		from {
			transform: translateY(100%);
			opacity: 0;
		}

		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	.frame {
		position: absolute;
		height: 100%;
		width: 100%;
		touch-action: pan-y !important;
	}

	.container-box {
		display: flex;
		flex-direction: column;


		.imgStyle {
			height: 100%;
			width: 100%;
		}

		.header {
			z-index: 999;
			top: 0;
			position: fixed;
			background-color: #fff;
			-webkit-transform: translateZ(0);
			opacity: 0.85;

			.headerFrame {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: 7.5vh;
				width: 100vw;
			}

			.headerChild {
				height: 59%;
				width: 100vw;
			}


		}

		.content {
			display: flex;
			flex-direction: column;
			margin-top: 7.5vh;
			width: 100vw;

			// 山哩商城
			.shoppingMall {
				display: flex;
				flex-direction: column;
				padding-left: 10px;
				padding-right: 10px;
				padding-bottom: 20px;

				.shoppingMallBg {
					height: 26vh;

				}

				.diagram {
					top: -5rem;
					position: relative;
					width: 80%;
				}

				.shoppingMallContent {
					margin-top: 0.2rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					background-color: #840000;
					color: #fff;

					.contentChild {
						top: 0rem;
						position: relative;
						height: 50%;
						display: flex;
						flex-direction: column;
						align-items: center;

						.contentFontFrame {
							font-weight: bold;
							padding: 0.5rem;
							border-bottom: solid 2px;
							font-size: 1.2rem;
						}

						.contentFontFrame1 {
							padding-top: 1rem;
							font-size: 0.9rem;
						}

						.contentFontFrame2 {
							font-size: 0.9rem;
						}

						.contentCode {
							margin: 1rem;
							width: 100%;
						}
					}
				}
			}

			// 服务店
			.serverFrame {
				/* margin-top: 1rem; */
				display: flex;
				justify-content: center;
				//flex-direction: column;
				align-items: center;
				width: 100%;
				background-color: #840000;
				/* height: 45vh; */

				.serverFrameFont {
					margin: 0.5rem 0.5rem;
					height: 30%;
					display: flex;
					flex-direction: column;
					align-items: center;
					color: #fff;

					.serverFrameTitle {
						padding: 0.5rem;
						font-weight: bold;
						font-size: 1.2rem;
						border-bottom: solid 2px #fff;
					}

					.serverFrameContent {
						padding-top: 0.5rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						font-size: 0.5rem;
					}
				}

				.serverFrameImg {
					margin-bottom: 1rem;
					height: 70%;
					width: 100%;
				}
			}

			// 农场
			.farmFrame {
				margin-top: 1rem;
				height: 60vh;
				display: flex;
				flex-direction: column;

				.farmFrameChild {
					height: 40%;
					width: 100%;
				}

				.farmFrameChild1 {
					margin-top: 2%;
					height: 58%;
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;

					.farmFrameChildImg {
						display: flex;
						justify-content: space-between;
						height: 50%;
						width: 96%;
						position: relative;
						top: 1rem;

						.farmFrameChildImg1 {
							height: 100%;
							width: 48%;
						}
					}

					.farmFrameChildContent {
						padding-top: 1rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						height: 50%;
						width: 100%;
						background-color: #840000;
						color: #fff;

						.farmChildFrame {
							width: 94%;
						}

						.farmChildFont {
							width: 35%;
							padding: 0.5rem;
							font-weight: bold;
							font-size: 1.2rem;
							border-bottom: solid 2px #fff;
						}

						.farmChildFont1 {
							margin-top: 1rem;
							font-size: 0.5rem;
						}
					}
				}
			}

			// 商学院
			.business {
				margin-top: 1rem;
				display: flex;
				flex-direction: column;
				height: 40vh;

				.businessHeader {
					padding: 1rem;
					height: 15%;
					background-color: #840000;
				}

				.businessMiddle {
					display: flex;
					justify-content: center;
					height: 40%;

					.businessMiddleImg {
						top: -1rem;
						position: relative;
						height: 20vh;
						width: 60%;
					}
				}

				.businessFooter {
					display: flex;
					flex-direction: column;
					justify-content: flex-end;
					align-items: center;
					height: 45%;
					width: 100%;
					background-color: #840000;

					.businessFooterChild {
						margin-bottom: 3%;
						height: 80%;
						width: 80%;
						color: #fff;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						.businessFooterFont {
							padding: 0.5rem;
							border-bottom: solid 2px;
							font-size: 1.2rem;
							font-weight: bold;
						}

						.businessFooterFont1 {
							margin-top: 0.5rem;
							display: flex;
							flex-direction: column;
							align-items: center;
							font-size: 0.5rem;
						}
					}
				}
			}
		}
	}

	.tabBarFontFrame {
		pointer-events: none;
		color: #fff;
		height: 5vh;
		width: 100%;
		position: absolute;
		top: 17.5vh;
		z-index: 3;
		display: flex;
		align-items: center;
		flex-direction: column;
		animation: moveUp 3s 1;

		.tabBarFont {
			letter-spacing: 2px;
			font-weight: bold;
			font-size: 1.3rem;
		}

		.tabBarFont1 {
			margin-top: 2%;
			font-size: 1rem;
			letter-spacing: 2px;
		}
	}

	.animation {
		animation: moveUp 3s 1;
	}

	.black-div {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.85);
		/* 设置背景色为半透明的黑色 */
		color: white;
		font-size: 24px;
		text-align: center;
		line-height: 100%;
		display: none;
	}

	.container {
		display: flex;
		/* 设置容器为flex布局 */
		justify-content: center;
		/* 设置水平居中 */
		align-items: center;
		/* 设置垂直居中 */
		padding-top: 15px;
	}

	.circle-div {
		width: 42px;
		/* 设置圆形DIV的宽度 */
		height: 42px;
		/* 设置圆形DIV的高度 */
		border-radius: 50%;
		/* 设置圆形DIV的边框半径为50% */
		background-color: white;
		/* 设置圆形DIV的背景色为绿色 */
		position: relative;
		/* 设置圆形DIV的定位为相对定位 */
	}

	.arrow-img {
		/* 设置图片的样式 */
		width: 54px;
		/* 设置图片的宽度 */
		height: 54px;
		/* 设置图片的高度 */
		position: absolute;
		/* 设置图片的定位为绝对定位 */
		top: 50%;
		/* 设置图片的上偏移为50% */
		left: 50%;
		/* 设置图片的左偏移为50% */
		transform: translate(-50%, -50%);
		/* 使用transform属性调整图片的位置，使其居中 */
	}

	.active {
		display: block;
	}

	.mg {
		margin-top: 30px;
	}

	.shade {
		position: absolute;
		top: 25%;
		width: 100%;
		text-align: center;

		.shade-title {
			font-size: 13px;
			padding-left: 20%;
			padding-right: 20%;
			text-align: justify;
		}

		.shade-line {
			height: 1px;
			width: 62px;
			background: #015198 none repeat scroll 0 0;
			margin: 12px auto 6px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/iphone/business.vue